<template>

  <div class="hero-body">
    <div class="container has-text-centered">
      <p class="title">
        <!-- Tweet My Slides -->
        <img id="main-logo"
             src="../assets/TweetMySlides-logo-white-cropped.png">
      </p>
      <p class="subtitle">
        Share your PowerPoint slides as a
        <a target="_blank"
           style="text-decoration: underline; opacity: 0.9;"
           href="https://twitter.com/niceplumage/status/942758121004466176">Twitter thread</a>.
      </p>
      <p class="subtitle">
        <!-- <a class="button is-link">Get started!</a> -->

        <div class="columns is-centered">

          <div class="column is-narrow">
            <router-link class="button is-primary"
                         to="/about">Read more...</router-link>
          </div>
          <div class="column is-narrow">
            <router-link class="button is-link"
                         to="/create">Get started!</router-link>
          </div>

        </div>
      </p>

      <div class="columns is-centered" style="margin-top: 10px; margin-bottom: -80px;">
        <div class="column is-narrow">

          <carousel :perPage="1"
                    :navigationEnabled="true"
                    :paginationActiveColor="'#3273dc'"
                    :paginationPadding="8"
                    :paginationSize="8"
                    style="width: 660px;">
            <slide>
              <iframe src="https://player.vimeo.com/video/247730736" 
                      width="640" 
                      height="360" 
                      frameborder="0" 
                      webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </slide>
            <slide>
              <img src="../assets/screenshots/01.png" class="screenshot" />
              <div>TweetMySlides works as either a standalone web app (tweetmyslides.com)...</div>
            </slide>
            <slide>
              <img src="../assets/screenshots/14.png" class="screenshot" />
              <div>...or directly from within PowerPoint as an Office add-in. (See the video for a full demonstration of the add-in in action).</div>
            </slide>
            <slide>
              <img src="../assets/screenshots/02.png" class="screenshot" />
              <div>To begin, you upload a presentation on the Create page...</div>
            </slide>
            <slide>
              <img src="../assets/screenshots/03.png" class="screenshot" />
              <div>...which is then processed on the server to convert it to images and extract the slide's text and notes.</div>
            </slide>       
            <slide>
              <img src="../assets/screenshots/04.png" class="screenshot" />
              <div>You can then choose which text to use (the slides or the notes), and any additional text to add to the start or end of each tweet.</div>
            </slide>    
            <slide>
              <img src="../assets/screenshots/06.png" class="screenshot" />
              <div>You can also edit any individual slide's content.</div>
            </slide>                                                  
            <slide>
              <img src="../assets/screenshots/07.png" class="screenshot" />
              <div>When you're finished, move on to the final step...</div>
            </slide>   
            <slide>
              <img src="../assets/screenshots/08.png" class="screenshot" />
              <div>...which is to authorize the application to tweet on your behalf. You launch a popup window to log in and authorize the app on Twitter.</div>
            </slide>   
            <slide>
              <img src="../assets/screenshots/09.png" class="screenshot" />
              <div>Once you're logged in via Twitter, you're good to go.</div>
            </slide>     
            <slide>
              <img src="../assets/screenshots/10.png" class="screenshot" />
              <div>After the slides have been tweeted, you can see a preview of them.</div>
            </slide>      
            <slide>
              <img src="../assets/screenshots/11.png" class="screenshot" />
              <div>Clicking on any of the preview tweets...</div>
            </slide>    
            <slide>
              <img src="../assets/screenshots/12.png" class="screenshot" />
              <div>...will take you to the thread on Twitter...</div>
            </slide>    
            <slide>
              <img src="../assets/screenshots/13.png" class="screenshot" />
              <div>...where you can see they're all linked together in the correct sequence. You're then ready to share the link to the first tweet.</div>
            </slide>                                                                                                                                
          </carousel>

        </div>
      </div>

    </div>
  </div>

</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "Home",

  components: {
    Carousel,
    Slide
  },

  data: function () {
    return {

    };
  },

  computed: {

  },

  methods: {

  },

  mounted () {

  }
};
</script>

</script>

<style lang="css" scoped>
.title img {
  margin-top: -5rem;
  margin-bottom: 1.5rem;
}

img.screenshot {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue